export default __webpack_public_path__ + "static/media/tecla.df21e035.mp3";